import ContainerBodyContainer from "./Containers/Body/container";
import ContainerContentContainer from "./Containers/Content/container";
import AssetsComponent from "./Containers/HTML/Assets/component";
import ContainerHTMLContainer from "./Containers/HTML/container";
import ContainerPopupContainer from "./Containers/Popup/container";
import ContainerRootContainer from "./Containers/Root/container";
import ContainerSidePanelContainer from "./Containers/SidePanel/container";
import DotsMenuContainer from "./DotsMenu/container";
import FooterContainer from "./Footer/container";
import HeaderContainer from "./Header/container";
import SidePanelToggleContainer from "./SidePanel/Toggle/container";
import SidePanelContainer from "./SidePanel/container";

export const Assets = AssetsComponent;
export const Footer = FooterContainer;
export const Header = HeaderContainer;
export const ContainerRoot = ContainerRootContainer;
export const ContainerHTML = ContainerHTMLContainer;
export const ContainerBody = ContainerBodyContainer;
export const ContainerSidePanel = ContainerSidePanelContainer;
export const ContainerContent = ContainerContentContainer;
export const ContainerPopup = ContainerPopupContainer;
export const DotsMenu = DotsMenuContainer;
export const SidePanel = SidePanelContainer;
export const SidePanelToggle = SidePanelToggleContainer;
